const ranking = [
  { rank: 1, title: '雷霆行动', type: '动作', trend: 'up', hot: true },
  { rank: 2, title: '欢乐一家人续集', type: '喜剧', trend: 'up', hot: true },
  { rank: 3, title: '霸王别姬 (4K修复版)', type: '经典', trend: 'new', hot: true },
  { rank: 4, title: '星际迷航全集', type: '科幻', trend: 'up', hot: false },
  { rank: 5, title: '第七重真相', type: '悬疑', trend: 'hot', hot: true },
  { rank: 6, title: '宫崎骏经典合集', type: '动画', trend: 'up', hot: false },
  { rank: 7, title: 'BBC自然系列全季', type: '纪录', trend: 'new', hot: false },
];

export default function RankingSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-accent-500';
    if (trend === 'new') return 'ri-sparkling-line text-primary-500';
    return 'ri-fire-line text-accent-600';
  };

  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            热播榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            本周最受关注影片排行榜，看看大家都在看什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
          {ranking.map((item, i) => (
            <a
              key={item.rank}
              href="#cards"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors duration-200 cursor-pointer ${
                i < ranking.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <span
                className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg text-sm font-bold ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-300 text-accent-900'
                    : item.rank === 3
                    ? 'bg-accent-200 text-accent-800'
                    : 'bg-secondary-100 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  {item.hot && (
                    <span className="flex-shrink-0 px-1.5 py-0.5 bg-primary-100 text-primary-700 text-xs rounded whitespace-nowrap">
                      热门
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.type}</p>
              </div>

              <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center">
                <i className={getTrendIcon(item.trend)}></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}